import template from './sites.html';

//Instantiate Page Variables 
var SitesViewModel = function(page)
{
	var self = this;
	self.page = page;
	this.sites = ko.observableArray();
}

//Handle interaction with page 
var Sites = function(bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new SitesViewModel(this);
	this.name = 'Add/Edit Sites';

	document.title = this.name;

	//Event (Post/After): Load once
	this.init = function() {

	};

	this.btnAddSite_click = function(model, e) {
		Grape.show_dialog('AddSite', {}, { onClose: function(d) {
			self.updateData();
		} });
	};

	//Event (Post/After): Refresh page data
	this.updateData = function() {

		$.postJSON("/grape/list", {schema:'account', tablename: 'sites', sortfield: 'site_name', sortorder: 'desc', }, function (res) {
			self.viewModel.sites(res.records);
		});
	};

	//Event (Pre/Before): Remove 
	this.teardown = function() {

    };
    

    this.btnAddSite_click = function(model, e) {
		Grape.show_dialog('AddSite', {}, { onClose: function(d) {
			self.updateData();
		} });
    };
    

	this.edit_site = function (v, e) {
		var data = ko.toJS(v);
		Grape.show_dialog('AddSite',data,  { 
			onClose: function(d) { 
				self.updateData();					
			}
		});
	};

};

export default {
	route: '[/]admin/sites', 
	page_class: Sites,
	template: template
};

